import { render, staticRenderFns } from "./_addBank.vue?vue&type=template&id=78f5b244&scoped=true&lang=pug&"
import script from "./_addBank.vue?vue&type=script&lang=js&"
export * from "./_addBank.vue?vue&type=script&lang=js&"
import style0 from "./_addBank.vue?vue&type=style&index=0&id=78f5b244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5b244",
  null
  
)

export default component.exports